module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("2")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("W")])])])]), _vm._v("hen I was fourteen, I read a book by Stephen King called "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Firestarter.")])]), _vm._v(" In it, one of the characters had the ability to compel others to do as he said. King called it the “push.” There were side effects, both on the guy doing the pushing and on those he pushed, and he could only do it when he had full control of his faculties and concentration.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I should be so lucky.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("My ability is different. The good news is, I don’t seem to do any damage to myself when I use it. The bad news is, I can do it any time, anywhere, regardless of my physical or mental condition. And sometimes it happens unintentionally.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("It didn’t start until I was an adolescent, and I had no idea what was happening. When I told another kid at school to shut up, he didn’t speak for months. I hadn’t a clue that the weeks of psychological testing, expulsion from school and the ridicule from other kids he had to endure were all due to my vehemence at the moment I said those two words.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I had "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("pressed")])]), _vm._v(" him. I could have saved him and his parents months of agony by saying, “Okay, you can talk again” with equal intensity, but I neither knew that I could nor did I have the opportunity once he was taken out of school. Nor did "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("he")])]), _vm._v(" know why he was unable to speak, or that I had anything to do with it. Poor kid. Eventually my instructions wore off, but he never caught up with the rest of his class and ultimately graduated a year late.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Not that I was still in the same school by then. My adoptive parents had given up soon after the first time I almost killed someone. The foster homes—and there had been many—were mostly situated far from the pleasant suburban communities with their pleasant suburban schools I had attended until I was in fifth grade.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As I readied myself for bed, I forced my mind away from the ugly memories tonight’s slipup had raised. After washing my face and brushing my teeth, I made myself do the short relaxation exercise I had learned in yoga class. My mind cleared as much as possible for now, I got into bed and invited Fred to join me. He did me the honor of agreeing.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("One little image sneaked in before I drifted off into alcohol-enhanced slumber. The look on Rocko’s face when I told him—pressed him—to be afraid of me. My last thought was the reason I was really so upset about losing control. It was because making that asshole frightened of me had felt "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("good.")])]), _vm._v(" And that feeling was what I was really afraid of.")])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span')]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The sleep that comes from tequila is not the same thing as real slumber. When I awakened to a horrible, piercing sound, it took me a few long seconds to identify its source. It was my cell phone, which I had remembered to put in the charger next to my pillow, but failed to reduce the ear-splitting volume setting I used for bars and other crowded, noisy settings.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I picked it up and punched the button but forgot what I was supposed to say. So I said nothing, and a voice at the other end asked, “Is anyone there? Hello?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yes, I’m here.” "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Shit.")])]), _vm._v(" Aspirin or no, my head hurt.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“May I speak to Mercedes Hollings?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Speaking.” I sat up, wondering who the hell would call me at…what? Three-forty-five in the morning.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Ms. Hollings, I’m calling from the emergency room at Hoag. There’s a Susan Keystone here. Your name is in her wallet as one of the people to call in case of an emergency.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Sukey? Is she all right?” My mind raced. Had Rocko beaten her up? Had she been in an accident?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“She’s being moved to intensive care.” This was not an answer to my question, but you don’t move corpses to intensive care.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’ll be right there.” I punched the off key and jumped to my feet, causing Fred to make a protesting sound. I no longer felt any effects of the alcohol, other than a pounding in my head as I leaned over to find a clean pair of jeans in my bottom drawer.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Less than two minutes later, I was driving down Balboa Boulevard at well over the speed limit. I hoped I would not get pulled over—this was a notorious speed trap—but I figured I could talk my way out of it under the circumstances. Hell, the cops probably all knew Sukey, too. She loved uniforms.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The Hoag Memorial Hospital parking lot was almost empty at this hour, and I was through the emergency room entrance in moments. “I’m here about Susan Keystone. I got a call—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Ms. Hollings? I’m the one who called you.” The woman behind the desk smiled warmly. People who say hospital staff members are impersonal or unfriendly have never been to Hoag. I swear they must send their personnel to hospitality management classes. “She’s in intensive care. We’re only supposed to let family in to see her, but she asked for you, and you were the only number we were able to reach on her emergency list.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Her father’s out of the country,” I said, remembering. “One of her sisters lives in San Diego, though. I’m sure she’ll want to come up. What happened to her?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“We left a message with a Regina Keystone at a San Diego area code. I’m not authorized to tell you any medical details, but if she’s told the doctor it’s okay to talk to you, you can get the details from him. Let me tell you how to get to the intensive care reception desk.” She handed me a brochure with a map. Hoag hospital has more in common with a good hotel than just friendly staff.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I found my way to the elevator and the seventh floor intensive care reception. The male nurse behind this counter was just as professional, if not quite as friendly, and led me down the hall to the room where Sukey was visible through a glass wall, hooked up to monitors. I told him I would like to see the doctor whenever possible, then went into the room to stand next to the bed. Sukey was sleeping, and I looked her over critically. I saw no bruises or bandages but got no other clues. I searched for a chart but didn’t see one. Sighing, I took the chair next to her bed and sat to wait.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Patience is not my strong suit. I hadn’t brought anything to read and I’ve never been able to sleep sitting up, so I spent the time on a couple of my favorite pastimes: guilt and self-retribution.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("I never should have left her alone in the bar.")])]), _vm._v(" Which was ridiculous. Sukey was thirty years old. I knew because I had contributed toward the stripper at the surprise party. She had certainly made it the two blocks home in much worse condition than I had left her in. But if I had stayed…")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("If I was going to press him anyway, I should have told Rocko to stay away from her.")])]), _vm._v(" This was really insane. First, the press had been totally unplanned. Second, I had no right interfering in Sukey’s love life, even if it was a train wreck. Rocko was a throwback but, for all I knew, he might have really cared for her. If Sukey had asked me for help, that would be different, but she hadn’t.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Maybe pressing him caused him to do something to hurt Sukey.")])]), _vm._v(" Here it was, the real crux of the matter. Rocko’s fear of me in the parking lot had been genuine. He had practically pissed himself. A guy like that doesn’t much like being afraid. Maybe as soon as he got inside he got mad at himself. He would have been confused, with no idea why he suddenly found me terrifying. He would have resented it and might have looked around for someone to take it out on. And since Sukey had introduced us…")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("My empty stomach churned uncomfortably. There was a very real possibility my stupid loss of control had resulted in Sukey’s current condition. This was why I couldn’t allow myself to have friends or let anyone get too close to me. Because I always ended up hurting them.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Ms. Hollings?” A softly accented voice interrupted my internal litany of self-loathing. I looked up into a pair of chocolate-brown eyes in a smooth face.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I am Dr. Patel,” said the young man. “Ms. Keystone was awake for a while and asked for you. I told her you would be called and asked her for permission to speak with you about her medical details.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I nodded my understanding.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Please, won’t you step out where we can talk without disturbing her?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I stood and followed him to a comfortable waiting room. A jigsaw puzzle was partially completed on the table, and a big-screen television was dark in a corner. Books and magazines filled shelves and tables. We sat in upholstered chairs.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“What happened to her?” I asked.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“It appears to be a drug overdose. Heroin, most likely.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Heroin? "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Sukey?")])]), _vm._v("” I shook my head at this impossibility. “Sukey would never use heroin. She’s terrified of needles.” I had gone with her once to get a tetanus shot, and she had been a wreck.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“She appears to have inhaled or smoked it,” he replied. “And it was probably cut with something that did her no good, either. Probably diphenhydramine, which sometimes triggers breathing problems, especially with asthmatics or people with allergies. Someone dumped her on the curb in front of the E.R. and took off.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I see.” I didn’t see, not really. Sukey liked to party, but heroin was way out of her league. She would never do it on her own. And though I thought I remembered her mentioning something about allergies one time, I hadn’t really paid attention, so I couldn’t say whether they were the problem.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Rocko.” I didn’t realize I had spoken aloud until I saw the inquisitive look on the doctor’s face. “Nothing. I was just thinking about—” I shook my head. “Is she going to be okay?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“She should be. We are going to keep her here at least twenty-four hours to make sure. She should be out of intensive care and in a regular room later this morning.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I nodded, and asked another question. “Does this have to be reported to the police?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Not unless they ask.” He smiled gently at me. “Ms. Hollings, you seemed very surprised to learn your friend had used heroin. How well do you know Ms. Keystone? Is it possible she has a problem with the drug?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I shook my head emphatically. “If Sukey took heroin, it was because she didn’t know what it was. You can take my word for it.” I meant it—meant it enough to press, just slightly. I had a firm policy of not pressing anyone without their permission, but exceptions could be made in the case of extreme emergencies. This definitely qualified.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Dr. Patel gave me a speculative look. He nodded and stood. “Ms. Keystone did ask that we call you, but I am reasonably sure she will not wake up for several hours. Perhaps you could get some rest and come back later.” He excused himself and left the room.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I decided to wait it out but desperately wanted a cigarette. I call myself a social smoker, which is pretty funny when you consider my social life. What I mean is, I don’t smoke every day or even every week. But when I do smoke, I may smoke an entire pack in a night. It all depends on my mood. I was pretty sure I had an almost full pack of Marlboro Lights in my glove compartment. The current situation had awakened dormant cravings.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I went out to the car, found the pack and lit up. The tobacco was stale, but I wasn’t really smoking for the taste. I had parked in a spot shadowed from the spotlights by a large royal palm, and I leaned against the side of my car and looked out over the lights of the Pacific Coast Highway and Newport Island. Dawn would not come for another couple of hours, and anyway, it took a long time to peek over the mountains to the east, which were rarely seen through the coastal haze.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Movement at the other end of the parking lot caught my attention. A sleek black Firebird cruised near the emergency room entrance, and although I could not see through the tinted windows, a rush of adrenaline made every nerve tingle. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("That son of a bitch. Too chickenshit to take her inside, but hanging around to see if she doesn’t make it and the cops show up.")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I completely forgot that less than four hours ago I had promised myself I would not use my abilities in anger ever again. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("I’ll press you this time, you cock-sucker. I’ll press you right off a cliff into the Newport Harbor.")])]), _vm._v(" Mindless of the consequences, I took off in a run after the black car. If I could just get within earshot before he saw me….")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Unfortunately, my Birkenstock sandals were not designed for sprinting. The car had turned, exposing Rocko’s face through the open driver’s side window, and I just had time to see the look of pure terror take over his features as he saw who was pounding across the parking lot toward him. Tires squealed as he accelerated toward the exit.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Shit!")])]), _vm._v(" I reversed directions, heading back for my Honda. He had a good start on me before I squealed my own tires, but fortunately the short, curvy drive leading down to the street did not let the larger engine of his muscle car give him an advantage over my more maneuverable vehicle. I was right on his tail when he hit the Coast Highway, but I had no chance to catch him on the straightaway.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("To my complete astonishment, the moron turned onto Newport Boulevard and headed down the peninsula. This was like a scene from "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("World’s Stupidest Criminals.")])]), _vm._v(" There were only two ways off the peninsula, and after Labor Day—two weeks ago—the Balboa Island Ferry stopped running at two in the morning. Rocko was heading toward a dead end, and I was right behind him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I kept my foot on the accelerator, but there was no way I was going to catch an eight-cylinder muscle car. It didn’t matter as long as I could see his taillights, and I wanted to hang back in case he tried to turn down one of the side streets and circle back behind me. I was hoping his panic wouldn’t wear off until he had driven too far down the peninsula for there to be a good place to turn around.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("You should be very afraid of me, Rocko. Terrified, in fact.")])]), _vm._v(" My own words echoed in my head. I had been sick and furious with myself for losing control. Now I just wanted to get close enough so I could press him again. If I could just get him to hear me yell “stop,” that would be enough.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Any other day of the year there would be one or two police cars lurking on the tiny side streets, waiting for incautious tourists to violate the twenty-five-miles-per-hour speed limit, but Rocko’s taillights continued to pull away. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Shit.")])]), _vm._v(" If he made it all the way to where the peninsula widened at the Wedge, it would be harder to trap him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I breathed a sigh of relief when I saw his brake lights flash as he slowed and made a fishtailing left turn toward the Balboa Island Ferry ramp. He must not have known it was closed. I took a turn down an alley and then went the wrong way down a tiny side street, cutting off his last chance to get around me and head back toward the mainland. I came around the corner in front of Jimbo’s, expecting to see Rocko’s car on the ramp to the ferry. It wasn’t there.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Damn, where is he?")])]), _vm._v(" I cruised slowly around the block, looking for the vehicle, but nothing was moving at this hour. As I pulled up along the main boulevard again, I caught a flash of movement in my rearview mirror. I twisted around just in time to see Rocko disappearing around a corner on foot, heading toward the silent and dark arcades and junk-food stands of the Fun Zone. The street was too narrow for a U-turn, so I made a couple of lefts and came around the tiny block, trying to cut him off. If I could just get where he could hear my voice…")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I pulled up as close as I could get to the string of arcades, slammed the car into Park and jumped out. The boardwalk was still and empty. Suddenly I heard the loud rumble of a boat’s engine starting up. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Jesus, why didn’t I think of that?")])]), _vm._v(" I ran out on the tiny public pier, nearly slipping on the steep ramp.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Where was the rumbling coming from? I scanned the smallish boats moored at the marina, but all were motionless. Then I saw a larger, darker movement beyond the still marina. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("I don’t fucking believe it. The moron is stealing the Balboa Island Ferry.")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I ran back to my car. There was no way I could make it back around to the tiny bridge before Rocko got the ferry over to the other side, then slipped into the warren of alleys and side streets of Balboa Island, but maybe a quick 911 call could get a reception committee there in time. As I threw the car into Reverse and backed toward the alley, I fumbled for my cell phone but hesitated before punching the number.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Did I want to call the police? They would trace the call and might want to know what I was doing on the boardwalk somewhere after four in the morning. I didn’t want to tell them anything that would lead back to Sukey, and I definitely did not want them around while I had a private chat with Rocko. But since it didn’t look like my chances for having that chat tonight were very high, I wouldn’t mind at all if he ended up spending the night in a cell.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I screeched to a halt in front of the liquor store and ran for the payphone. I dialed 911 and got an answer on the first ring. Newport Beach, California, does "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("not")])]), _vm._v(" suffer from a shortage of law enforcement resources.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Someone just stole the Balboa Island Ferry from the Fun Zone. He’s heading for Balboa Island.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Who’s calling, please?” I slammed down the receiver, wiped off the handset with my sleeve and was back in the car within ten seconds. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Calm down, girl. You can’t get to him tonight. Just take a deep breath and get your ass back to the hospital….")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Before I could take my own advice, the unmistakable sound of an enormous crash sent a frisson of apprehension through my limbs. “Holy shit!” I pulled out of the parking lot and looked around. I thought the sound had come from the direction of the ferry ramp, and I turned that way. I couldn’t see the source, but the loud "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("crump")])]), _vm._v(" of an explosion told me where it had to be. I screeched to a halt at the base of the ramp and saw I was right.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Rocko had driven the ferry directly into the gas dock in front of Butchie’s Balboa Boat Rentals, and the outlines of the burning pumps could be seen through the dancing flames on the ferry’s deck—now jammed between the pilings of the ferry ramp and the rental slip entrance, half over the floating dock. I smiled grimly. The single-screw ferries were notoriously difficult to steer, especially when it was windy, and the idiot hadn’t even made it to the opposite side of the channel. He had made an arc right back into the shore where he’d started.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The live-aboard residents in the marina were popping out of their boat cabins like groundhogs. They were on the other side of the ferry slip, away from the danger, but one figure charged toward the flames like an Olympic runner. I just had time to realize it was Sam, naked except for a pair of boxer shorts, when another fast-moving figure caught my eye. It was Rocko, running in the opposite direction.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As they say in the police reports, I gave chase. Abandoning my useless sandals, I took off like the sprinter I had wanted to be in high school. I passed Sam, seeing him check as recognition registered in his eyes, but neither of us stopped. I rounded the corner and saw Rocko crossing the boulevard in the direction of the Balboa Pier.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Rocko, stop!” I shrieked, pressing with all my might, but he was too far ahead of me to understand my words and intent.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He headed out onto the pier. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("What is it with this guy and dead ends?")])]), _vm._v(" I didn’t have time to argue with miracles. I slowed down, knowing this time he really had nowhere to go, unless he jumped into the frigid Pacific. As I caught my breath, I reflected I really wouldn’t mind if he drowned or got eaten by one of the great white sharks that are occasionally reeled in by anglers fishing off the pier. But I knew that when my fury wore off, I would not want to have a man’s death on my hands, even if that man was scum. So I slowed to a fast walk, hoping a slower pursuit would prevent him from panicking.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The pier was well-lit, but the retro diner poised at its end hid the farthest portion from view. He was probably huddled on the far side of the building, waiting for the big, bad, boogey-person to get him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Rocko, come out where I can see you,” I shouted over the wind and crashing waves. I didn’t know for sure if I could press without visual contact, but I tried anyway. I figured he could probably hear me now. Sure enough, he came around one side of the building and stood under a light. I could see him trembling as I walked closer.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“D-d-don’t do anything to me,” he said in the tone of a scared child. With his bulging muscles and deep voice, it was eerily incongruous.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Come over here and stand out of the wind,” I said, continuing to press. He did as he was told, still shaking. I could have told him to stop being afraid. I didn’t.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I want to talk to you about Sukey. Do you understand me?” He nodded, and I could see the whites all the way around the dark pupils of his eyes as his face caught the lamplight. “Tell me what drug you gave her.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Heroin.” The expression on his face told me it caused him pain to speak, but he was compelled to do so.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Why did you give it to her?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“To make her be quiet.” He licked his lips and swallowed, looking at me like a rabbit caught in front of a coyote.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Why did you need her to be quiet? What was she making noise about?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“She wouldn’t shut up. She kept crying.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Why was she crying? Did you hurt her?” If I had been entertaining any thoughts of giving Rocko a break, they evaporated.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“She said I only wanted to fuck her.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“And did you?” When Rocko didn’t answer immediately, I realized he needed a clearer question. This guy really was a moron.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“And did you have sex with her? Did you force her?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I didn’t have to force her. She wanted to.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“She wanted to before the heroin? Or was it after?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Before…both.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I took a few minutes to think about it, while Rocko stood jittering and shaking like he was freezing. I had a pretty good idea about what had happened, even if I didn’t have a lot of details. They didn’t really matter, anyway, and I could get them from Sukey later. Right now, I just wanted to get rid of this guy.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Where’s your car?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Jimbo’s.” I hadn’t even checked the parking lot, but it made sense he would abandon it somewhere he had been before.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Here’s what you’re going to do. Are you paying attention?” He quickly nodded, moaning in a combination of eagerness and terror. “When I say you can go, you are going to go get in your car. There are probably going to be a lot of police around the ferry and the marina, and I want you to get to your car without any of them seeing you. Can you do that?” He nodded, and I continued.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Then, you are going to get into your car and drive carefully out of town. You are not going to speed or do anything that might get the police’s attention. Pick up any of your things you need, and then go far, far away. Never come back. Never call Sukey or anyone else from this town. Never tell anyone where you have gone. Flush all your heroin and any other drugs you have hanging around down the toilet, gas up your car and leave. You understand me?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Again that rapid nodding.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Good. Now go.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("It was as if I had fired the starting pistol at a track meet. Rocko shot past me toward the base of the pier. As he ran by, I could smell his sweat and urine. He had pissed himself.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I watched until his dark form reached the boardwalk, then vanished between two houses. I walked over to the edge of the pier and, making sure the wind was behind me, vomited for the second time in less than five hours. There wasn’t much left to come up.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5d2ada6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/begformercy_ch02.vue
// module id = 69
// module chunks = 0